import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import React from 'react';

const TITLE_TEXT = 'Confirm Apply';
const DESCRIPTION_TEXT =
  'Applying will reorder the data division inside the chart and reset all edited data. Do you want to proceed?';
const CONFIRM_BUTTON_TEXT = 'Confirm';
const CANCEL_BUTTON_TEXT = 'Cancel';

interface IDialogProps {
  isDialogOpen: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  titleText?: string;
  descriptionText?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

export const FormDialogBox: React.FC<IDialogProps> = ({
  handleCancel,
  isDialogOpen,
  handleConfirm,
  cancelButtonText = CANCEL_BUTTON_TEXT,
  confirmButtonText = CONFIRM_BUTTON_TEXT,
  descriptionText = DESCRIPTION_TEXT,
  titleText = TITLE_TEXT,
}) => {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{titleText}</DialogTitle>
      <DialogContent>
        <div className="text-sm text-secondary_text">{descriptionText}</div>
      </DialogContent>
      <DialogActions>
        <ButtonDesigned style="outline" onButtonClick={handleCancel} className="text-blue-600">
          {cancelButtonText}
        </ButtonDesigned>
        <ButtonDesigned style="primary" onButtonClick={handleConfirm}>
          {confirmButtonText}
        </ButtonDesigned>
      </DialogActions>
    </Dialog>
  );
};
